import { useMutation } from '@tanstack/react-query';
import useApi from '../../api/backendApiContext';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import { FundingDto } from '../fundingApi';

export const useUpdateTenantNotificationSettingsMutation = () => {
  const { fundingApi } = useApi();
  const queryCacheManager = useQueryCacheManager();

  return useMutation(async (funding: FundingDto) => fundingApi.updateFunding(funding), {
    onMutate: (funding: FundingDto) => queryCacheManager.updateFunding(funding),
  });
};
